import ConfirmationPage from "./ConfirmationPageContainer";
export default ConfirmationPage;
